import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"
import { Info } from "lucide-react"
import { memo } from "react";

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map((toastProps) => (
        <MemoizedToast key={toastProps.id} {...toastProps} />
      ))}
      <ToastViewport containerRef={ toasts.length && toasts?.reduce((toast) => toast)?.containerRef } />
    </ToastProvider>
  );
}

const MemoizedToast = memo(function MemoizedToast({
  id,
  title,
  description,
  variant,
  action,
  ...props
}) {
  return (
    <Toast key={id} variant={variant} onPointerLeave={()=> props?.onOpenChange(false)}  {...props} >
      <div className="flex gap-2 w-full">
        {/* {variant === "info" || variant === "warning" && (
          <div className="flex-shrink-0">
            <Info className="h-4 w-4 text-primary" />
          </div>
        )} */}
        <div className="flex-1 grid gap-1">
          {title && <ToastTitle>{title}</ToastTitle>}
          {description && <ToastDescription>{description}</ToastDescription>}
        </div>
        {action}
      </div>
      <ToastClose />
    </Toast>
  )
});